import {AfterViewInit, Component, OnInit} from '@angular/core';
import * as $ from 'jquery';
import {Router} from '@angular/router';
import {HttpClient} from '@angular/common/http';

@Component({
  selector: 'app-mainindex',
  templateUrl: './mainindex.component.html',
  styleUrls: ['./mainindex.component.css']
})
export class MainindexComponent implements OnInit {

  // baseUrl = "https//tsic.dbd.go.th:5300/";
  // baseUrl = "https://10.6.98.161:5300/";
  // baseUrl = "https://10.6.98.168:5200/";
  // baseUrl = "http://127.0.0.1:5300/";
  // business_group:any = [];

  constructor(private router: Router, private http:HttpClient) { }

  ngOnInit(): void {
    $(document).ready(() => {
      // console.log('load success !!');
      $.getScript('../assets/js/custom.js');
      // console.log('load custom.js success !!');
      $.getScript('../assets/js/scripts/suggessionWord.js');
      // console.log('load suggessionWord success !!');
      // $.getScript('../assets/js/scripts/searchResult.js');
      // console.log('load searchResult success !!');
    });
    // this.getBusinessGroup();
  }

  // async getBusinessGroup(){
  //   let response = await fetch(`${this.baseUrl}api/SearchCountBusinessType`);
  //   let data_json = await response.json()
  //   this.business_group = data_json.data;
  //   // console.log(this.business_group);
  // }

  public searchData(textSearch: string, selectType: string){
    // console.log("textSearch : "+textSearch);
    this.router.navigate(['../searchResult'], {queryParams: {textSearch: textSearch, selectType: selectType} }).then(() => window.location.reload());
  }

  public searchByCategory(value: string){
    this.router.navigate(['../brows_tsic'], {queryParams: {category: value} });
  }

}
